import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function tkValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let tk = control?.value;
    if (!tk || typeof tk === "object") return null;

    if (!tk.match(/^[0-9]*$/) || tk.length > 5) return { tk: true };

    return null;
  };
}